import usePredictivePreloading from '../../hooks/usePredictivePreloading';

/**
 * Componente utilitário que ativa o precarregamento preditivo
 * Não renderiza nada na UI, apenas gerencia o precarregamento em segundo plano
 */
const PredictivePreloader = () => {
  // Ativar o hook de precarregamento preditivo
  usePredictivePreloading();
  
  // Não renderiza nada na interface
  return null;
};

export default PredictivePreloader; 